var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3343C18.2091 21.3343 20 19.5434 20 17.3343C20 15.1251 18.2091 13.3343 16 13.3343C13.7909 13.3343 12 15.1251 12 17.3343C12 19.5434 13.7909 21.3343 16 21.3343Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.0877C4 13.3219 4 12.939 4.0987 12.5864C4.18614 12.274 4.32982 11.9802 4.5227 11.7195C4.74045 11.425 5.04269 11.19 5.64719 10.7198L14.6903 3.68631C15.1587 3.32197 15.3929 3.1398 15.6515 3.06978C15.8797 3.00799 16.1203 3.00799 16.3485 3.06978C16.6071 3.1398 16.8413 3.32197 17.3097 3.68631L26.3528 10.7198C26.9573 11.19 27.2596 11.425 27.4773 11.7195C27.6702 11.9802 27.8139 12.274 27.9013 12.5864C28 12.939 28 13.3219 28 14.0877V23.7343C28 25.2278 28 25.9745 27.7094 26.5449C27.4537 27.0467 27.0457 27.4546 26.544 27.7103C25.9735 28.001 25.2268 28.001 23.7333 28.001H8.26667C6.77319 28.001 6.02646 28.001 5.45603 27.7103C4.95426 27.4546 4.54631 27.0467 4.29065 26.5449C4 25.9745 4 25.2278 4 23.7343V14.0877Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome04);
export default __webpack_public_path__ + "static/media/home-04.c312551a72fe3359371ddac52b2e2903.svg";
export { ForwardRef as ReactComponent };